import { SelectOption } from '@/types/form.type.ts';

export enum CarStatus {
    Draft = 'draft',
    OnApproval = 'on_approval',
    OnRevision = 'on_revision',
    Approved = 'approved',
    OnAuction = 'on_auction',
    Sold = 'sold',
    Deleted = 'deleted',
    NotRealized = 'not_realized',
}

export function getCarStatusLabel(status: CarStatus): string {
    switch (status) {
        case CarStatus.Draft:
            return 'Черновик';
        case CarStatus.OnApproval:
            return 'На утверждении';
        case CarStatus.OnRevision:
            return 'На доработке';
        case CarStatus.Approved:
            return 'Утвержден';
        case CarStatus.OnAuction:
            return 'На аукционе';
        case CarStatus.Sold:
            return 'Продан';
        case CarStatus.Deleted:
            return 'Удален';
        case CarStatus.NotRealized:
            return 'Не реализован';
    }
}

export function getCarStatusSelectOptions(): SelectOption[] {
    const options: SelectOption[] = [];

    Object.values(CarStatus).forEach((status: CarStatus) => {
        options.push({
            label: getCarStatusLabel(status),
            value: status,
        });
    });

    return options;
}
